import { API_HOST_WMS } from "config/api.config";
import { api } from "network/network";
import { APIendpoints } from "utils/constants/APIendpoints";
import { normalizeUserRole, USER_ROLE_CONFIG } from "./userRoles";
import { isValidEmail, isValidPhoneNumber } from "./userValidation";

export const normalizeMappingPhone = (phone = "") => {
  const digits = String(phone).replace(/\D/g, "");
  return digits.length === 12 && digits.startsWith("91")
    ? digits.slice(2)
    : digits;
};

export const buildUserMappingPayload = ({
  outletId,
  userId = 0,
  phone = "",
  email = "",
  name = "",
  role,
}) => {
  const sellerOutletId = Number(outletId);
  const phoneNumber = normalizeMappingPhone(phone);
  const normalizedEmail = email.trim().toLowerCase();
  const normalizedName = name.trim();
  const normalizedRole = normalizeUserRole(role);

  if (!Number.isInteger(sellerOutletId) || sellerOutletId <= 0) {
    throw new Error("No outlet is selected.");
  }
  if (!isValidPhoneNumber(phoneNumber) && !isValidEmail(normalizedEmail)) {
    throw new Error(
      "A valid email address or 10-digit phone number is required."
    );
  }
  if (phoneNumber && !isValidPhoneNumber(phoneNumber)) {
    throw new Error("Enter a valid 10-digit phone number.");
  }
  if (normalizedEmail && !isValidEmail(normalizedEmail)) {
    throw new Error("Enter a valid email address.");
  }
  if (!USER_ROLE_CONFIG[normalizedRole]) {
    throw new Error("Select a valid role.");
  }

  return {
    create_user_and_seller_outlet_mapping_requests: [
      {
        seller_outlet_id: sellerOutletId,
        user_id: Number(userId) || 0,
        phone_number: phoneNumber,
        email: normalizedEmail,
        name: normalizedName,
        role: normalizedRole,
      },
    ],
  };
};

export const createUserAndMapToOutlet = async (mappingDetails) => {
  const payload = buildUserMappingPayload(mappingDetails);
  const response = await api.post(
    API_HOST_WMS,
    APIendpoints.createSellerOutletToUserMapping,
    payload
  );

  return response?.data?.response;
};

export const getUserMappingErrorMessage = (error) =>
  error?.response?.data?.error?.message ||
  error?.message ||
  "We couldn't add this user. Please try again.";

export const isDuplicateUserMappingError = (error) => {
  const status = error?.response?.status;
  const errorCode =
    error?.response?.data?.error?.code ||
    error?.response?.data?.code ||
    "";
  const message = getUserMappingErrorMessage(error);
  const duplicateDescription = `${errorCode} ${message}`;

  return (
    status === 409 ||
    /already\s+(exists|registered)|duplicate/i.test(duplicateDescription)
  );
};
